
  import { defineComponent, ref, reactive, toRefs, inject, defineAsyncComponent, onMounted } from 'vue';
  import * as _ from 'lodash';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';

  export default defineComponent({
    name: 'WidgetInputs',
    components: {
      FormBuilder: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormBuilder.vue'),
      ),
      WidgetInputs: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./WidgetInputs.vue'),
      ),
      FormInput: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormInput.vue'),
      ),
      FormFileInput: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormFileInput.vue'),
      ),
      FormDateInput: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormDateInput.vue'),
      ),
      FormCheckboxInput: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormCheckboxInput.vue'),
      ),
      FormRadioInput: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormRadioInput.vue'),
      ),
      FormLabel: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormLabel.vue'),
      ),
      RecursiveSelect: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./RecursiveSelect.vue'),
      ),
      RecursiveSection: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./RecursiveSection.vue'),
      ),

      Field,
      ErrorMessage,
    },
    props: {
      item: Object,
      items: Object,
      iterator: Object,
      enabled: Boolean,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      const state = reactive({
        item: props.item,
        items: props.items,
        iterator: props.iterator,
        enabled: props.enabled,
      });

      onMounted(() => {
        if (!state.enabled) {
          if (state.item) state.item.is_editable = false;
        }
        if (state.item) {
          if (!state.item.hasOwnProperty('is_hidden')) {
          state.item.is_hidden = false;
          }
          if (!state.item.hasOwnProperty('start_line')) {
          state.item.start_line = false;
          }
        }
      });

      const getSelectValue = (item, val) => {
        let Gitem: any = null;
        _.forEach(item.selection_values, (_item) => {
          if (_item.id == val) {
            Gitem = _item;
          }
        });
        return Gitem;
      };

      const updateParentItems = (items) => {
        state.items = items;
        context.emit('updateParentItems', items);
      };
      const updateSectionItems = (items) => {
        state.items = items;
      };

      return {
        updateParentItems,
        updateSectionItems,
        getSelectValue,
        ...toRefs(state),
        i18n,
        helpers,
      };
    },
  });
